module.exports = __webpack_public_path__ + "static/media/star.0b560f44.svg";